import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-content-card',
    templateUrl: './content-card.component.html',
    styleUrls: ['./content-card.component.scss'],
    standalone: false
})
export class ContentCardComponent {

  @Input() title!: string | null;
  @Input() subtitle!: string | null;
  @Input() cardTextPrefix!: string | null;
  @Input() cardText!: string | null;
  @Input() displayTitle: boolean = true;
  @Input() displaySubtitle: boolean = true;
  @Input() displayCardText: boolean = true;
  @Input() busy!: boolean;
  @Input() empty!: boolean;
}
